import type { ActionHandler } from "./registry";

/** Невидимость на N кадров: соперник не видит героя, зоны попаданий остаются. params: { frames } */
export const invisible: ActionHandler = ({ self }, { frames = 120 }) => {
  self.invisible = frames;
};

/** Броня: следующие N ударов не сбивают героя, урон проходит. params: { hits } */
export const armor: ActionHandler = ({ self }, { hits = 1 }) => {
  self.armor = hits;
};
